var _path, _g, _g2, _g3, _g4, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderBgTablet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 804,
    viewBox: "0 0 768 804",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 66C108 66 128 22 0 0V804C128 782 108 738 384 738C660 738 640 782 768 804V0C640 22 660 66 384 66Z",
    fill: "url(#paint0_linear_49_4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M551.8 613.9C553.5 615.1 555.4 616.5 557.7 618.3C569.9 627.2 611 656.4 654.7 657.5C646.5 659.6 637.9 660.7 629 660.7C605.4 660.6 583.7 652.3 566.5 638.6C559.9 630.9 555.1 622.7 551.8 613.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M548.7 620.3C546 616.7 543.5 612.9 541.3 609C541.9 608.7 543 608.7 544.6 609.5C545.8 613.2 547.2 616.8 548.7 620.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.201 584.7C540.501 591 541.401 597.2 542.901 603.4C541.201 603 539.7 603.1 538.5 603.6C533.6 593.4 530.3 582.3 529 570.5C533 576.6 536.201 581.1 540.201 584.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M542.5 554.8C541 562.1 540.2 569.4 540.1 576.8C535 572.9 531 568.2 528.5 562.4C528.5 561.3 528.4 560.2 528.4 559C528.5 549.3 529.9 539.9 532.5 531C533.8 539.4 536.4 548.4 542.5 554.8Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M544.1 548.1C538 543 535.3 532.3 537.7 517.4C553.8 482.5 589.2 458.3 630.1 458.5C632.5 458.5 634.9 458.6 637.2 458.8C590.8 465.5 555.6 504.3 544.1 548.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M629.9 529.3C584.8 553.6 570.4 558.5 550.7 551.4C566.4 489.1 621.4 460.3 658.8 462.8C681.3 469.6 700.5 484 713.4 503C695.8 499 680.5 503.8 629.9 529.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M627.4 647.5C617 644.4 570 617.8 563.9 614.7C561.2 613.3 555.1 608.8 549.3 605.9C547.9 600.5 547.1 595 546.7 589.4C554.5 593.8 565.9 597 586 601.4C615.3 609.8 677.2 619.4 729.5 575.2C724.5 607.6 704.1 634.9 676.1 649.5C655.4 653.6 648.6 652.8 627.4 647.5Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M589.1 595.2C573.4 591.6 558.1 587.6 546.5 581C546.6 576.5 546.9 572 547.6 567.4C547.9 564.8 548.4 562.2 548.8 559.6C558.3 564.8 573.1 565.5 596.6 557.2C621.2 545.7 677.1 508.7 701 508.8C706 508.8 710.401 507.2 716.901 508.6C725.701 523.7 730.801 541.3 730.701 560.1C730.701 562.5 730.601 565 730.401 567.4C710.601 588.4 649.5 612.4 589.1 595.2Z",
    fill: "#1C2624"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M600.4 218.1C601.2 218.7 602.2 219.4 603.2 220.2C609 224.5 628.8 238.5 649.8 239.1C645.8 240.1 641.7 240.6 637.4 240.6C626 240.5 615.6 236.6 607.4 230C604.2 226.3 601.9 222.3 600.4 218.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M598.9 221.2C597.6 219.5 596.4 217.7 595.4 215.8C595.7 215.6 596.2 215.7 597 216C597.5 217.7 598.1 219.5 598.9 221.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M594.8 204C595 207 595.4 210 596.1 213C595.3 212.8 594.5 212.8 594 213.1C591.6 208.2 590.1 202.9 589.4 197.2C591.3 200.2 592.9 202.3 594.8 204Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M595.901 189.7C595.201 193.2 594.801 196.7 594.701 200.3C592.201 198.4 590.301 196.1 589.101 193.4C589.101 192.9 589.101 192.3 589.101 191.8C589.101 187.1 589.801 182.6 591.101 178.3C591.701 182.3 592.901 186.6 595.901 189.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M596.701 186.4C593.801 184 592.501 178.8 593.601 171.6C601.301 154.8 618.301 143.2 638.001 143.3C639.201 143.3 640.301 143.4 641.401 143.5C619.101 146.7 602.201 165.4 596.701 186.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M637.901 177.4C616.201 189.1 609.301 191.4 599.801 188C607.301 158.1 633.801 144.2 651.801 145.4C662.601 148.7 671.901 155.6 678.001 164.7C669.601 162.8 662.201 165.2 637.901 177.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M636.701 234.2C631.701 232.7 609.101 219.9 606.201 218.4C604.901 217.7 602.001 215.6 599.201 214.2C598.501 211.6 598.1 209 598 206.3C601.8 208.4 607.201 209.9 616.901 212.1C631.001 216.1 660.801 220.8 685.901 199.5C683.501 215.1 673.701 228.2 660.201 235.2C650.201 237.2 646.901 236.8 636.701 234.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M618.301 209.1C610.701 207.4 603.401 205.5 597.801 202.3C597.801 200.1 598.001 198 598.301 195.8C598.501 194.5 598.701 193.3 598.901 192.1C603.401 194.6 610.601 195 621.901 191C633.701 185.5 660.601 167.7 672.101 167.7C674.501 167.7 676.601 166.9 679.701 167.6C683.901 174.9 686.401 183.3 686.301 192.4C686.301 193.6 686.201 194.7 686.101 195.9C676.701 205.8 647.301 217.4 618.301 209.1Z",
    fill: "#1C2624"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M631.8 378.7C632.9 379.5 634.2 380.4 635.6 381.5C643.5 387.3 670.3 406.3 698.6 407C693.3 408.4 687.7 409.1 681.9 409.1C666.5 409 652.5 403.7 641.3 394.8C637.1 389.8 633.9 384.4 631.8 378.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M629.8 382.9C628 380.6 626.4 378.1 625 375.6C625.4 375.4 626.1 375.4 627.1 375.9C627.9 378.3 628.8 380.6 629.8 382.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M624.3 359.8C624.5 363.9 625.1 368 626.1 371.9C625 371.7 624 371.7 623.2 372C620 365.4 617.9 358.1 617 350.5C619.5 354.5 621.7 357.4 624.3 359.8Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M625.8 340.3C624.8 345 624.3 349.8 624.2 354.6C620.9 352.1 618.3 349 616.7 345.2C616.7 344.5 616.7 343.7 616.7 343C616.7 336.7 617.7 330.6 619.4 324.8C620.1 330.3 621.8 336.2 625.8 340.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M626.8 336C622.8 332.7 621.1 325.7 622.6 316C633.1 293.3 656 277.6 682.7 277.7C684.3 277.7 685.8 277.8 687.3 277.9C657.1 282.3 634.3 307.5 626.8 336Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M682.5 323.7C653.2 339.5 643.9 342.7 631 338.1C641.2 297.6 676.9 278.9 701.2 280.5C715.8 284.9 728.3 294.3 736.7 306.6C725.3 304.1 715.4 307.2 682.5 323.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M680.9 400.5C674.1 398.5 643.6 381.2 639.6 379.2C637.8 378.3 633.9 375.4 630.1 373.5C629.2 370 628.6 366.4 628.4 362.8C633.5 365.7 640.8 367.7 653.9 370.6C672.9 376 713.2 382.3 747.1 353.6C743.8 374.7 730.6 392.4 712.4 401.9C699.1 404.5 694.7 404 680.9 400.5Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M656 366.6C645.8 364.2 635.9 361.7 628.3 357.4C628.4 354.5 628.6 351.5 629 348.6C629.2 346.9 629.5 345.2 629.8 343.6C635.9 347 645.6 347.5 660.9 342.1C676.9 334.6 713.2 310.6 728.7 310.6C731.9 310.6 734.8 309.6 739 310.5C744.7 320.3 748 331.8 747.9 344C747.9 345.6 747.8 347.2 747.7 348.7C735 362.2 695.3 377.8 656 366.6Z",
    fill: "#1C2624"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M216.2 613.9C214.5 615.1 212.6 616.5 210.3 618.3C198.1 627.2 157 656.4 113.3 657.5C121.5 659.6 130.1 660.7 139 660.7C162.6 660.6 184.3 652.3 201.5 638.6C208.1 630.9 212.9 622.7 216.2 613.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M219.3 620.3C222 616.7 224.5 612.9 226.7 609C226.1 608.7 225 608.7 223.4 609.5C222.2 613.2 220.8 616.8 219.3 620.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M227.8 584.7C227.5 591 226.6 597.2 225.1 603.4C226.8 603 228.3 603.1 229.5 603.6C234.4 593.4 237.7 582.3 239 570.5C235 576.6 231.8 581.1 227.8 584.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M225.5 554.8C227 562.1 227.8 569.4 227.9 576.8C233 572.9 237 568.2 239.5 562.4C239.5 561.3 239.6 560.2 239.6 559C239.5 549.3 238.1 539.9 235.5 531C234.2 539.4 231.6 548.4 225.5 554.8Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M223.9 548.1C230 543 232.7 532.3 230.3 517.4C214.2 482.5 178.8 458.3 137.9 458.5C135.5 458.5 133.1 458.6 130.8 458.8C177.2 465.5 212.4 504.3 223.9 548.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.1 529.3C183.2 553.6 197.6 558.5 217.3 551.4C201.6 489.1 146.6 460.3 109.2 462.8C86.7001 469.6 67.5001 484 54.6001 503C72.2001 499 87.5001 503.8 138.1 529.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M140.6 647.5C151 644.4 198 617.8 204.1 614.7C206.8 613.3 212.9 608.8 218.7 605.9C220.1 600.5 220.9 595 221.3 589.4C213.5 593.8 202.1 597 182 601.4C152.7 609.8 90.8 619.4 38.5 575.2C43.5 607.6 63.9 634.9 91.9 649.5C112.6 653.6 119.4 652.8 140.6 647.5Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.9 595.2C194.6 591.6 209.9 587.6 221.5 581C221.4 576.5 221.1 572 220.4 567.4C220.1 564.8 219.6 562.2 219.2 559.6C209.7 564.8 194.9 565.5 171.4 557.2C146.8 545.7 90.9 508.7 67 508.8C62 508.8 57.6 507.2 51.1 508.6C42.3 523.7 37.2 541.3 37.3 560.1C37.3 562.5 37.4 565 37.6 567.4C57.4 588.4 118.5 612.4 178.9 595.2Z",
    fill: "#1C2624"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.6 218.1C166.8 218.7 165.8 219.4 164.8 220.2C159 224.5 139.2 238.5 118.2 239.1C122.2 240.1 126.3 240.6 130.6 240.6C142 240.5 152.4 236.6 160.6 230C163.8 226.3 166.1 222.3 167.6 218.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.1 221.2C170.4 219.5 171.6 217.7 172.6 215.8C172.3 215.6 171.8 215.7 171 216C170.5 217.7 169.9 219.5 169.1 221.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.2 204C173 207 172.6 210 171.9 213C172.7 212.8 173.5 212.8 174 213.1C176.4 208.2 177.9 202.9 178.6 197.2C176.7 200.2 175.1 202.3 173.2 204Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.1 189.7C172.8 193.2 173.2 196.7 173.3 200.3C175.8 198.4 177.7 196.1 178.9 193.4C178.9 192.9 178.9 192.3 178.9 191.8C178.9 187.1 178.2 182.6 176.9 178.3C176.3 182.3 175.1 186.6 172.1 189.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.3 186.4C174.2 184 175.5 178.8 174.4 171.6C166.7 154.8 149.7 143.2 130 143.3C128.8 143.3 127.7 143.4 126.6 143.5C148.9 146.7 165.8 165.4 171.3 186.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M130.1 177.4C151.8 189.1 158.7 191.4 168.2 188C160.7 158.1 134.2 144.2 116.2 145.4C105.4 148.7 96.1002 155.6 90.0002 164.7C98.4002 162.8 105.8 165.2 130.1 177.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.3 234.2C136.3 232.7 158.9 219.9 161.8 218.4C163.1 217.7 166 215.6 168.8 214.2C169.5 211.6 169.9 209 170 206.3C166.2 208.4 160.8 209.9 151.1 212.1C137 216.1 107.2 220.8 82.1001 199.5C84.5001 215.1 94.3001 228.2 107.8 235.2C117.8 237.2 121.1 236.8 131.3 234.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.7 209.1C157.3 207.4 164.6 205.5 170.2 202.3C170.2 200.1 170 198 169.7 195.8C169.5 194.5 169.3 193.3 169.1 192.1C164.6 194.6 157.4 195 146.1 191C134.3 185.5 107.4 167.7 95.9002 167.7C93.5002 167.7 91.4002 166.9 88.3002 167.6C84.1002 174.9 81.6002 183.3 81.7002 192.4C81.7002 193.6 81.8002 194.7 81.9002 195.9C91.3002 205.8 120.7 217.4 149.7 209.1Z",
    fill: "#1C2624"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.2 378.7C135.1 379.5 133.8 380.4 132.4 381.5C124.5 387.3 97.7001 406.3 69.4001 407C74.7001 408.4 80.3001 409.1 86.1001 409.1C101.5 409 115.5 403.7 126.7 394.8C130.9 389.8 134.1 384.4 136.2 378.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.2 382.9C140 380.6 141.6 378.1 143 375.6C142.6 375.4 141.9 375.4 140.9 375.9C140.1 378.3 139.2 380.6 138.2 382.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.7 359.8C143.5 363.9 142.9 368 141.9 371.9C143 371.7 144 371.7 144.8 372C148 365.4 150.1 358.1 151 350.5C148.5 354.5 146.3 357.4 143.7 359.8Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M142.2 340.3C143.2 345 143.7 349.8 143.8 354.6C147.1 352.1 149.7 349 151.3 345.2C151.3 344.5 151.3 343.7 151.3 343C151.3 336.7 150.3 330.6 148.6 324.8C147.9 330.3 146.2 336.2 142.2 340.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.2 336C145.2 332.7 146.9 325.7 145.4 316C134.9 293.3 112 277.6 85.3002 277.7C83.7002 277.7 82.2002 277.8 80.7002 277.9C110.9 282.3 133.7 307.5 141.2 336Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.5 323.7C114.8 339.5 124.1 342.7 137 338.1C126.8 297.6 91.1001 278.9 66.8001 280.5C52.2001 284.9 39.7 294.3 31.3 306.6C42.7 304.1 52.6 307.2 85.5 323.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.1001 400.5C93.9001 398.5 124.4 381.2 128.4 379.2C130.2 378.3 134.1 375.4 137.9 373.5C138.8 370 139.4 366.4 139.6 362.8C134.5 365.7 127.2 367.7 114.1 370.6C95.1001 376 54.8001 382.3 20.9001 353.6C24.2001 374.7 37.4001 392.4 55.6001 401.9C68.9001 404.5 73.3001 404 87.1001 400.5Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112 366.6C122.2 364.2 132.1 361.7 139.7 357.4C139.6 354.5 139.4 351.5 139 348.6C138.8 346.9 138.5 345.2 138.2 343.6C132.1 347 122.4 347.5 107.1 342.1C91.1001 334.6 54.8001 310.6 39.3001 310.6C36.1001 310.6 33.2001 309.6 29.0001 310.5C23.3001 320.3 20.0001 331.8 20.1001 344C20.1001 345.6 20.2001 347.2 20.3001 348.7C33.0001 362.2 72.7001 377.8 112 366.6Z",
    fill: "#1C2624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49_4",
    x1: -9.00002,
    y1: 795,
    x2: 777,
    y2: 8.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9082A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBgTablet);
export default __webpack_public_path__ + "static/media/header-bg-tablet.b2fafa1c620220b42da65d60058b5279.svg";
export { ForwardRef as ReactComponent };